function callAll(...fns) {
    return function (...args) {
        fns.forEach(fn => fn === null || fn === void 0 ? void 0 : fn(...args));
    };
}
export { callAll };
//# sourceMappingURL=callAll.js.map